module.exports = __webpack_public_path__ + "static/img/dy.ad091b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dy.png
// module id = c0Ke
// module chunks = 0